import { combineReducers } from 'redux';
import { loginStateReducer, userInfStateReducer } from './login/login';
import { donorIdStateReducer, ReloadDonorDataReducer } from './checkin/checkin';
import { DonorStateReducer } from './donorList/donorList'
import { isChangeStateReducer, isDetectLoadingStateReducer, isSideStatusStateReducer, isSokectIdReducer, isSokectIdReducerLeft } from './isChange/isChange';
import { roomRecordStateReducer } from './roomRecord/roomRecord'
import { webSocketStateReducer } from './webSocket/webSocket'
import { queueReducer, socketConnectReducer } from './webSocket/queueReducer'
import { visitStateReducer } from './visit/visit'
import { medicalTemplateDataReducer } from './medicalTemplate/medicalTemplate';
import { donoCollectionCountReducer, donoCollectionLoadReducer, donoCollectionReducer, donorINFReducer, donorScreeningReducer, indenTifyProcessDataReducer, kpiDataReducer } from './medicalTemplate/kpiDataReducer';
import { queueDataReducer } from './queue/queueAction';
const rootReducer = combineReducers({
    loginStateReducer,
    userInfStateReducer,
    ReloadDonorDataReducer,
    DonorStateReducer,
    isChange: isChangeStateReducer,
    isSideStatusStateReducer: isSideStatusStateReducer,
    isDetectLoadingState: isDetectLoadingStateReducer,
    isSokectIdReducer: isSokectIdReducer,
    isSokectIdLeftReducer: isSokectIdReducerLeft,
    roomRecordStateReducer,
    webSocketStateReducer,
    visitStateReducer,
    medicalTemplateDataReducer: medicalTemplateDataReducer,
    kpiDataReducer: kpiDataReducer,
    indenTifyProcessDataReducer: indenTifyProcessDataReducer,
    donorINFReducer: donorINFReducer,
    donorScreeningReducer: donorScreeningReducer,
    donoCollectionReducer: donoCollectionReducer,
    donoCollectionCountReducer: donoCollectionCountReducer,
    donoCollectionLoadReducer: donoCollectionLoadReducer,
    queueReducer: queueReducer,
    socketConnectReducer: socketConnectReducer,
    queueDataReducer: queueDataReducer,
    donorIdStateReducer: donorIdStateReducer
})

export default rootReducer